import React from 'react';
import HSTable from '../../../../../../../common/HSTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../store/rootReducer';
import { Security } from '../../../../../redux/types';
import { Empty, Spin } from 'antd';

const SecuritiesTableView: React.FC = () => {
    const loading = useSelector((state: RootState) => state.investments.sLoading);
    const list = useSelector((state: RootState) => state.investments.security);

    const columns = [
        {
            dataIndex: 'securityType',
            title: 'Type of Security',
        },
        {
            dataIndex: 'rank',
            title: 'Rank',
        },
        {
            dataIndex: 'typeOfAsset',
            title: 'Type of Asset',
        },
        {
            dataIndex: 'collateralization',
            title: 'Collateralization',
            render: (text: string, row: Security) => (
                <span>
                    {text && row.collateralizationType === 'Percentage'
                        ? `${parseFloat(text).toFixed(2)} ${row.collateralizationType === 'Percentage' ? '%' : ''}`
                        : text || ''}
                </span>
            ),
        },
        {
            dataIndex: 'assetOwner',
            title: 'Asset Owner',
        },
        {
            dataIndex: 'description',
            title: 'Description',
        },
    ];
    return (
        <div>
            {!loading && list.length > 0 && (
                <HSTable columns={columns} data={list} loading={loading} rowKey={(d: Security) => `${d.uuid}`} />
            )}
            {!loading && list.length === 0 && (
                <div>
                    <Empty description={`No Securities Data`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            )}
            {loading && (
                <div className="flex justify-center items-center py-4">
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default SecuritiesTableView;
